import { render, staticRenderFns } from "./LocationAddNew.vue?vue&type=template&id=57d55008&scoped=true&"
import script from "./LocationAddNew.vue?vue&type=script&lang=js&"
export * from "./LocationAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LocationAddNew.vue?vue&type=style&index=0&id=57d55008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d55008",
  null
  
)

export default component.exports